import {BarChart, LocalPrintshop, NotificationsActive, Publish, Search} from '@mui/icons-material';
import UnderConstructionPage from '../pages/other/UnderConstructionPage';
import {FeatureObject} from '../types/FeatureObject';
import {FeatureStatus} from '../types/FeatureStatus';

export const etsySeo: FeatureObject = {
  type: 'feature',
  title: 'SEO Optimization Tools',
  description: 'Powerful tools to help you optimize your listings for Etsy search, increasing visibility and sales.',
  IconComponent: Search,
  showFeatureFrontPage: true,
  path: '/etsySeo',
  component: () => <UnderConstructionPage />,
  status: FeatureStatus.PLANNED,
  tags: ['etsy', 'seo', FeatureStatus.PLANNED],
};

export const etsyAnalytics: FeatureObject = {
  type: 'feature',
  title: 'Analytics Dashboard',
  description: "Gain insights into your shop's performance with detailed analytics and reports.",
  IconComponent: BarChart,
  showFeatureFrontPage: true,
  path: '/etsyAnalytics',
  component: () => <UnderConstructionPage />,
  status: FeatureStatus.PLANNED,
  tags: ['etsy', 'analytics', FeatureStatus.PLANNED],
};

export const etsyDeliveryNote: FeatureObject = {
  type: 'feature',
  title: 'Delivery Note Printing',
  description: 'Quickly print delivery notes for faster order processing and shipping.',
  IconComponent: LocalPrintshop,
  showFeatureFrontPage: true,
  path: '/etsyDeliveryNote',
  component: () => <UnderConstructionPage />,
  status: FeatureStatus.PLANNED,
  tags: ['etsy', 'order', FeatureStatus.PLANNED],
};

export const etsyOrderAlert: FeatureObject = {
  type: 'feature',
  title: 'Order Alerts',
  description: 'Receive notifications for new orders, ensuring you never miss a sale.',
  IconComponent: NotificationsActive,
  showFeatureFrontPage: true,
  path: '/etsyOrderAlert',
  component: () => <UnderConstructionPage />,
  status: FeatureStatus.PLANNED,
  tags: ['etsy', 'order', FeatureStatus.PLANNED],
};

export const etsyScheduledListingPublish: FeatureObject = {
  type: 'feature',
  title: 'Scheduled Listing Publish',
  description: 'Set a date and time to automatically publish your listings.',
  IconComponent: Publish,
  showFeatureFrontPage: true,
  path: '/etsyScheduledListingPublish',
  component: () => <UnderConstructionPage />,
  status: FeatureStatus.PLANNED,
  tags: ['etsy', 'listing', 'publish', FeatureStatus.PLANNED],
};
